import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Raven from 'raven-js';
import { ENVIRONMENT } from '../environments/environment';
import { StartupService } from './services/startup/startup.service';
Raven.config(ENVIRONMENT.sentry_dns).install();
const ɵ0 = (createTranslateLoader), ɵ1 = window.location, ɵ2 = (startupServiceFactory);
export class AppModule {
} // end class AppModule
/**
 * Function > createTranslateLoader
 * @param {HttpClient} OBJ_http_client
 * @returns {TranslateHttpLoader}
 */
export function createTranslateLoader(OBJ_http_client) {
    // die Abkuerzung i18n ist ein Numeronym und steht fuer Internationalization
    return new TranslateHttpLoader(OBJ_http_client, 'assets/i18n/', '.json');
} // end function createTranslateLoader
/**
 * Function > startupServiceFactory
 * @param {StartupService} OBJ_startup_service
 * @return {Function}
 */
export function startupServiceFactory(OBJ_startup_service) {
    console.log({ class: 'AppModule', function: 'startupServiceFactory' }, 'config_path: ' + ENVIRONMENT.config_path);
    return () => OBJ_startup_service.load(ENVIRONMENT.config_path);
} // end function startupServiceFactory
export { ɵ0, ɵ1, ɵ2 };
